module.exports = __webpack_public_path__ + "static/media/img-background4.a5e6362c.jpg";